/**
 * Rebind the logged-in SyncTrack JWT onto Connected SYNCTRACK connector rows.
 * Clients without the Connector menu need this after every login so Chat Hub / MCP keep working.
 */
export async function syncSyncTrackSession(token = localStorage.getItem('token')) {
  if (!token || !String(token).trim()) {
    return { skipped: true, reason: 'no-token' };
  }

  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/?$/, '/');
  const tenantId = localStorage.getItem('tenantId');
  const tenantDbPath = localStorage.getItem('tenantDbPath') || localStorage.getItem('tenant_db_path');

  const headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${String(token).trim()}`,
  };
  if (tenantId) {
    headers['X-Tenant-Id'] = tenantId;
  }
  if (tenantDbPath) {
    headers.db_name = tenantDbPath;
    headers.TENANT_DB_PATH = tenantDbPath;
  }

  try {
    const res = await fetch(`${base}synctrack/synctrack-connector/sync-session`, {
      method: 'POST',
      headers,
    });
    if (!res.ok) {
      const text = await res.text().catch(() => '');
      console.warn('SyncTrack session sync failed:', res.status, text);
      return { ok: false, status: res.status, message: text };
    }
    const data = await res.json().catch(() => ({}));
    console.log('SyncTrack session synced onto connectors:', data);
    return { ok: true, data };
  } catch (e) {
    console.warn('SyncTrack session sync error:', e?.message || e);
    return { ok: false, message: e?.message || String(e) };
  }
}
